import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { LuPencil } from 'react-icons/lu';
import { Contract } from 'shared/models/contract';
import { useFinancialContext } from '../../FinancialContext';
import ChangeDueDateModal from '../modals/ChangeDueDateModal';
import ChangePaymentMethodModal from '../modals/ChangePaymentMethodModal';

interface PaymentMethodActionsMenuProps {
  loading?: boolean;
  contract: Contract;
}

const PaymentMethodActionsMenu = ({
  loading,
  contract,
}: PaymentMethodActionsMenuProps) => {
  const {
    openChangePaymentMethodModal,
    openChangeDueDateModal,
    onCloseChangePaymentMethodModal,
    onCloseChangeDueDateModal,
    changePaymentMethodModalOpen,
    changeDueDateModalOpen,
  } = useFinancialContext();

  return (
    <>
      <Menu variant="plainSmall">
        <MenuButton
          as={Button}
          size="xs"
          leftIcon={<LuPencil size="13" />}
          isDisabled={loading}
          color={'yPrimary.600'}
          variant={'plainIcon'}
          iconSpacing={'none'}
          fontWeight={500}
          fontSize={'14px'}
          maxHeight={'32px'}
        >
          Trocar
        </MenuButton>
        <MenuList>
          <MenuItem onClick={openChangePaymentMethodModal}>
            Método de pagamento
          </MenuItem>
          <MenuItem onClick={openChangeDueDateModal}>Vencimento</MenuItem>
        </MenuList>
      </Menu>

      <ChangePaymentMethodModal
        isOpen={changePaymentMethodModalOpen}
        onClose={onCloseChangePaymentMethodModal}
        contract={contract}
      />
      <ChangeDueDateModal
        isOpen={changeDueDateModalOpen}
        onClose={onCloseChangeDueDateModal}
        contract={contract}
      />
    </>
  );
};

export default PaymentMethodActionsMenu;
